import { configureStore as toolkitConfigureStore } from "@reduxjs/toolkit";
import rootReducer from "../reducers";

export default function configureStore(preloadedState: any) {
  return toolkitConfigureStore({
    reducer: rootReducer,
    preloadedState,
    devTools: true,
    middleware: (getDefaultMiddleware) =>
      getDefaultMiddleware({
        serializableCheck: {
          ignoredPaths: ["fileUploadList", "currentFileUploadProperties", "fileUploadProperties"],
          ignoredActions: ["fileUploadList/setFileUploadData", "fileUploadList/updateFileUploadData"],
        },
      }),
  });
}
